import createClient, { type Client } from "openapi-fetch";
import type { paths } from "./schema";

export type ApiClient = Client<paths>;

export type ApiClientOptions = {
  /** Абсолютный origin backend; для same-origin — origin самого приложения. */
  baseUrl: string;
  fetch: (request: Request) => Promise<Response>;
};

export function createApiClient({ baseUrl, fetch }: ApiClientOptions): ApiClient {
  // credentials: "include" — refresh-cookie должна уходить и при отдельном BUN_PUBLIC_API_BASE_URL.
  return createClient<paths>({ baseUrl, fetch, credentials: "include" });
}
